import { InputData } from "@/types";
import { createContext } from "react";

const AppContext = createContext<InputData>({});

export default AppContext;
